import { yupResolver } from "@hookform/resolvers/yup";
import FormButtons, { FormButtonInterface } from "components/forms/buttons";
import { CancelButton, SubmitButton } from "components/forms/buttons.utils";
import Form from "components/forms/form";
import TextInput from "components/forms/inputs/text";
import Col from "components/grid/col";
import Grid from "components/grid/grid";
import Row from "components/grid/row";
import { Admin } from "models/admin";
import { FunctionComponent } from "react";
import { useForm } from "react-hook-form";
import { useLocale } from "stores/hooks/locale";
import * as yup from "yup";

interface AdminFormProps {
  admin?: Admin;
  onSubmit: (values: any) => Promise<void>;
  onClose: () => Promise<void>;
}

const AdminForm: FunctionComponent<AdminFormProps> = ({
  admin,
  onSubmit,
  onClose,
}) => {
  const locale = useLocale();

  const schema = yup
    .object(
      admin
        ? {
            firstname: yup.string().validateRequired(),
            lastname: yup.string().validateRequired(),
            locale: yup.string().validateRequired(),
            email: yup.string().validateEmail().validateRequired(),
            //password: yup.string().validatePassword(),
            phone: yup.string().validatePhone(),
            ssn: yup.string().validateSsn(),
          }
        : {
            firstname: yup.string().validateRequired(),
            lastname: yup.string().validateRequired(),
            locale: yup.string().validateRequired(),
            email: yup.string().validateEmail().validateRequired(),
            password: yup.string().validatePassword().validateRequired(),
            phone: yup.string().validatePhone(),
            ssn: yup.string().validateSsn(),
          },
    )
    .required();

  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      firstname: admin?.firstname || "",
      lastname: admin?.lastname || "",
      locale: admin?.locale || locale,
      email: admin?.email || "",
      password: "",
      ssn: admin?.ssn || "",
      phone: admin?.phone || "",
    },
  });

  const buttons: FormButtonInterface[] = [
    { ...CancelButton, onClick: onClose },
    { ...SubmitButton },
  ];

  return (
    <Form methods={methods} onSubmit={onSubmit}>
      <Grid>
        <Row>
          <Col>
            <TextInput required name="firstname" label="Etunimi" />
          </Col>
          <Col>
            <TextInput required name="lastname" label="Sukunimi" />
          </Col>
        </Row>
        <Row>
          <Col>
            <TextInput required name="email" label="Sähköpostiosoite" />
          </Col>
          <Col>
            <TextInput
              password
              required={admin === undefined}
              disabled={admin !== undefined}
              name="password"
              label="Salasana"
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <TextInput name="ssn" label="Henkilötunnus" />
          </Col>
          <Col>
            <TextInput name="phone" label="Puhelinnumero" />
          </Col>
        </Row>
        <FormButtons buttons={buttons} />
      </Grid>
    </Form>
  );
};

export default AdminForm;
